export default __webpack_public_path__ + "static/media/services.8ffbf27c.jpg";